import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { dashboardRoute, homeRoute, loginRoute, notFoundRoute } from '@/app/router/routes'
import { RequireAuth } from './RequireAuth'
import { PageLoader } from '@/shared/ui/PageLoader/PageLoader'

export function AppRouter() {
  const HomePage = homeRoute.component
  const DashboardPage = dashboardRoute.component
  const LoginPage = loginRoute.component
  const NotFoundPage = notFoundRoute.component

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path={homeRoute.path} element={<HomePage />} />
        <Route path={loginRoute.path} element={<LoginPage />} />
        <Route
          path={dashboardRoute.path}
          element={
            <RequireAuth>
              <DashboardPage />
            </RequireAuth>
          }
        />
        <Route path={notFoundRoute.path} element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  )
}
